import { TrialCancelledListPage } from "@/features/rso/pages/TrialCancelledList";
import React from "react";

const TrialCancelledList = () => {
  return <TrialCancelledListPage />;
};

export default TrialCancelledList;
